import { render, staticRenderFns } from "./_collectionHandle.vue?vue&type=template&id=bc7e6720&scoped=true&"
import script from "./_collectionHandle.vue?vue&type=script&lang=js&"
export * from "./_collectionHandle.vue?vue&type=script&lang=js&"
import style0 from "./_collectionHandle.vue?vue&type=style&index=0&id=bc7e6720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7e6720",
  null
  
)

export default component.exports